<template>
  <div v-if="drawerOpen">
    <!-- Overlay -->
    <div class="nd-overlay" @click="close"></div>

    <!-- Drawer -->
    <div class="nd-drawer">
      <!-- Header -->
      <div class="nd-header">
        <div class="nd-header-left">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
          <span class="nd-header-title">Notificaciones</span>
          <span v-if="unreadCount > 0" class="nd-header-badge">{{
            unreadCount
          }}</span>
        </div>
        <button class="nd-close" @click="close">
          <i class="el-icon-close"></i>
        </button>
      </div>

      <!-- Filter tabs -->
      <div class="nd-tabs">
        <button
          v-for="tab in tabs"
          :key="tab.value"
          :class="['nd-tab', { active: activeFilter === tab.value }]"
          @click="setFilter(tab.value)"
        >
          {{ tab.label }}
        </button>
      </div>

      <!-- Body -->
      <div class="nd-body">
        <!-- Loading -->
        <div v-if="loading" class="nd-loading">
          <div v-for="n in 4" :key="n" class="nd-skeleton-item">
            <div class="sk-dot"></div>
            <div class="sk-lines">
              <div class="sk-line w70"></div>
              <div class="sk-line w50"></div>
            </div>
          </div>
        </div>

        <!-- Items -->
        <template v-else-if="activeItems.length">
          <!-- Urgentes -->
          <template v-if="urgentGroup.length">
            <div class="nd-section-label">Requieren accion</div>
            <transition-group name="nd-item-fade" tag="div">
              <div
                v-for="item in urgentGroup"
                :key="item.id"
                :class="['nd-item', { 'is-unread': !item.is_read }]"
                :style="{ borderLeftColor: severityColor(item.severity) }"
              >
                <div class="nd-item-top">
                  <span
                    class="nd-dot"
                    :style="{ background: severityColor(item.severity) }"
                  ></span>
                  <span class="nd-item-title">{{ item.title }}</span>
                  <span :class="['nd-tag', 'tag-' + item.severity]">{{
                    severityLabel(item.severity)
                  }}</span>
                </div>
                <p class="nd-item-desc">{{ item.description }}</p>
                <div class="nd-item-meta">
                  <span class="nd-item-time">{{
                    timeAgo(item.updated_at)
                  }}</span>
                </div>
                <div class="nd-item-actions">
                  <button
                    v-if="item.action_label"
                    class="nd-action-btn"
                    @click="onAction(item)"
                  >
                    {{ item.action_label }}
                  </button>
                  <button
                    class="nd-dismiss-btn"
                    @click="onDismiss(item.id)"
                    title="Descartar"
                  >
                    <i class="el-icon-close"></i>
                  </button>
                </div>
              </div>
            </transition-group>
          </template>

          <!-- Oportunidades -->
          <template v-if="opportunityGroup.length">
            <div class="nd-section-label">Oportunidades</div>
            <transition-group name="nd-item-fade" tag="div">
              <div
                v-for="item in opportunityGroup"
                :key="item.id"
                :class="['nd-item', { 'is-unread': !item.is_read }]"
                :style="{ borderLeftColor: severityColor(item.severity) }"
              >
                <div class="nd-item-top">
                  <span
                    class="nd-dot"
                    :style="{ background: severityColor(item.severity) }"
                  ></span>
                  <span class="nd-item-title">{{ item.title }}</span>
                  <span :class="['nd-tag', 'tag-' + item.severity]">{{
                    severityLabel(item.severity)
                  }}</span>
                </div>
                <p class="nd-item-desc">{{ item.description }}</p>
                <div class="nd-item-meta">
                  <span class="nd-item-time">{{
                    timeAgo(item.updated_at)
                  }}</span>
                </div>
                <div class="nd-item-actions">
                  <button
                    v-if="item.action_label"
                    class="nd-action-btn"
                    @click="onAction(item)"
                  >
                    {{ item.action_label }}
                  </button>
                  <button
                    class="nd-dismiss-btn"
                    @click="onDismiss(item.id)"
                    title="Descartar"
                  >
                    <i class="el-icon-close"></i>
                  </button>
                </div>
              </div>
            </transition-group>
          </template>

          <!-- Informativas -->
          <template v-if="infoGroup.length">
            <div class="nd-section-label">Informativas</div>
            <transition-group name="nd-item-fade" tag="div">
              <div
                v-for="item in infoGroup"
                :key="item.id"
                :class="['nd-item', { 'is-unread': !item.is_read }]"
                :style="{ borderLeftColor: severityColor(item.severity) }"
              >
                <div class="nd-item-top">
                  <span
                    class="nd-dot"
                    :style="{ background: severityColor(item.severity) }"
                  ></span>
                  <span class="nd-item-title">{{ item.title }}</span>
                  <span :class="['nd-tag', 'tag-' + item.severity]">{{
                    severityLabel(item.severity)
                  }}</span>
                </div>
                <p class="nd-item-desc">{{ item.description }}</p>
                <div class="nd-item-meta">
                  <span class="nd-item-time">{{
                    timeAgo(item.updated_at)
                  }}</span>
                </div>
                <div class="nd-item-actions">
                  <button
                    v-if="item.action_label"
                    class="nd-action-btn"
                    @click="onAction(item)"
                  >
                    {{ item.action_label }}
                  </button>
                  <button
                    class="nd-dismiss-btn"
                    @click="onDismiss(item.id)"
                    title="Descartar"
                  >
                    <i class="el-icon-close"></i>
                  </button>
                </div>
              </div>
            </transition-group>
          </template>
        </template>

        <!-- Empty -->
        <div v-else class="nd-empty">
          <i class="el-icon-circle-check"></i>
          <span>Todo al dia</span>
        </div>
      </div>

      <!-- Footer -->
      <div v-if="unreadCount > 0" class="nd-footer">
        <button class="nd-mark-all" @click="markAllRead">
          Marcar todas como leidas
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/config/Api";

export default {
  name: "NotificationDrawer",
  data() {
    return {
      tabs: [
        { label: "Todas", value: "all" },
        { label: "Urgentes", value: "urgent" },
        { label: "Informativas", value: "info" }
      ]
    };
  },
  computed: {
    drawerOpen() {
      return this.$store.state.notificationsStore.drawerOpen;
    },
    leadsBaseUrl() {
      if (process.env.VUE_APP_LEADS_URL) {
        return process.env.VUE_APP_LEADS_URL.replace(/\/leads\/?$/, "");
      }
      if (typeof window !== "undefined" && window.location && window.location.host) {
        const host = window.location.host;
        if (host.indexOf("app.mydessk.com") !== -1) {
          return "https://" + host.replace("app.mydessk.com", "marketing.mydessk.com");
        }
      }
      return "";
    },
    loading() {
      return this.$store.state.notificationsStore.loading;
    },
    activeFilter() {
      return this.$store.state.notificationsStore.activeFilter;
    },
    activeItems() {
      return this.$store.getters["notificationsStore/activeItems"];
    },
    unreadCount() {
      return this.$store.state.notificationsStore.unreadCount;
    },
    urgentGroup() {
      return this.activeItems.filter(n =>
        ["urgent", "warning"].includes(n.severity)
      );
    },
    opportunityGroup() {
      return this.activeItems.filter(n => n.severity === "opportunity");
    },
    infoGroup() {
      return this.activeItems.filter(n => n.severity === "info");
    }
  },
  watch: {
    drawerOpen(val) {
      if (val) {
        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", this.onEscape);
      } else {
        document.body.style.overflow = "";
        document.removeEventListener("keydown", this.onEscape);
      }
    }
  },
  beforeDestroy() {
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.onEscape);
  },
  methods: {
    close() {
      this.$store.dispatch("notificationsStore/closeDrawer");
    },
    setFilter(filter) {
      this.$store.dispatch("notificationsStore/setFilter", filter);
    },
    async onAction(item) {
      this.$store.dispatch("notificationsStore/markRead", [item.id]);

      if (item.action_url) {
        // Rutas del módulo Leads (marketing.mydessk.com) — usar handoff igual que openLeads()
        if (item.action_url.startsWith("/leads")) {
          this.close();
          const user = JSON.parse(localStorage.getItem("user") || "{}");
          const token = user && user.token ? user.token : "";
          const base = this.leadsBaseUrl;
          if (token) {
            window.location.href =
              base +
              "/auth/handoff#token=" +
              encodeURIComponent(token) +
              "&next=" +
              encodeURIComponent(item.action_url);
          } else {
            window.location.href = base + item.action_url;
          }
          return;
        }

        try {
          const url = new URL(item.action_url, window.location.origin);
          const action = url.searchParams.get("action");

          if (action) {
            this.$root.$emit("notification-action", action);
            this.close();
            return;
          }

          let path = item.action_url;

          const legacyShort = path.match(/^\/quotes\/(\d+)$/);
          const singularOld = path.match(
            /^\/dashboard\/ventas\/cotizacion\/(\d+)$/
          );
          const withVersion = path.match(
            /^\/dashboard\/ventas\/cotizaciones\/(\d+)\/version\/(\d+)$/
          );

          if (legacyShort || singularOld) {
            const quoteId = (legacyShort || singularOld)[1];
            path = await this.resolveQuotePath(quoteId);
          } else if (withVersion) {
            // Already correct format — use as-is
          } else {
            const legacyInvoice = path.match(/^\/invoices\/(\d+)$/);
            if (legacyInvoice) {
              path = "/dashboard/ventas/factura/" + legacyInvoice[1];
            }
          }

          this.$router.push(path).catch(() => {});
        } catch (e) {
          this.$router.push(item.action_url).catch(() => {});
        }
      }

      this.close();
    },

    async resolveQuotePath(quoteId) {
      try {
        const response = await Api().get(`/quotes/${quoteId}`);
        const quote = response.data?.quote;
        // API returns versions[] sorted latest first
        const versionId = quote?.versions?.[0]?.id || null;
        if (versionId) {
          return `/dashboard/ventas/cotizaciones/${quoteId}/version/${versionId}`;
        }
      } catch (e) {
        // fall through
      }
      return "/dashboard/ventas";
    },
    async onDismiss(id) {
      try {
        await this.$store.dispatch("notificationsStore/dismiss", id);
      } catch (e) {
        this.$message.error("No se pudo descartar la notificación");
      }
    },
    async markAllRead() {
      await this.$store.dispatch("notificationsStore/markRead", "all");
      this.$message.success("Todas marcadas como leídas");
    },
    severityColor(severity) {
      const map = {
        urgent: "#e24b4a",
        warning: "#ba7517",
        opportunity: "#1d9e75",
        info: "#534ab7"
      };
      return map[severity] || "#909399";
    },
    severityLabel(severity) {
      const map = {
        urgent: "Urgente",
        warning: "Atencion",
        opportunity: "Oportunidad",
        info: "Info"
      };
      return map[severity] || severity;
    },
    timeAgo(dateStr) {
      if (!dateStr) return "";
      const now = new Date();
      const date = new Date(dateStr);
      const diffMs = now - date;
      const diffMin = Math.floor(diffMs / 60000);
      if (diffMin < 1) return "ahora";
      if (diffMin < 60) return `hace ${diffMin} min`;
      const diffH = Math.floor(diffMin / 60);
      if (diffH < 24) return `hace ${diffH}h`;
      const diffD = Math.floor(diffH / 24);
      if (diffD === 1) return "ayer";
      return `hace ${diffD} dias`;
    },
    onEscape(e) {
      if (e.key === "Escape") this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #31355c;
$accent: #3ecfb4;
$border: #e4eaf6;
$bg: #f7f8f9;

// Overlay
.nd-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2000;
}

// Drawer
.nd-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 380px;
  height: 100vh;
  background: #fff;
  z-index: 2001;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
  animation: slide-in 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes slide-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

// Header
.nd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid $border;
  flex-shrink: 0;
}
.nd-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
  color: $primary;
}
.nd-header-title {
  font-size: 15px;
  font-weight: 600;
}
.nd-header-badge {
  background: #e24b4a;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 18px;
  height: 18px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
}
.nd-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 6px;
  color: #909399;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: $bg;
    color: $primary;
  }
}

// Tabs
.nd-tabs {
  display: flex;
  padding: 0 20px;
  border-bottom: 1px solid $border;
  flex-shrink: 0;
}
.nd-tab {
  flex: 1;
  padding: 10px 0;
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s;
  &:hover {
    color: $primary;
  }
  &.active {
    color: $primary;
    border-bottom-color: $accent;
  }
}

// Body
.nd-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

// Section labels
.nd-section-label {
  font-size: 10px;
  font-weight: 700;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 12px 20px 6px;
}

// Item
.nd-item {
  padding: 12px 20px;
  border-left: 3px solid transparent;
  border-bottom: 1px solid $border;
  position: relative;
  transition: background 0.12s;
  &.is-unread {
    background: #fafbff;
  }
  &:hover {
    background: $bg;
  }
  &:hover .nd-dismiss-btn {
    opacity: 1;
  }
}
.nd-item-top {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}
.nd-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.nd-item-title {
  font-size: 13px;
  font-weight: 600;
  color: $primary;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nd-tag {
  font-size: 9px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  flex-shrink: 0;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  &.tag-urgent {
    background: #fcebeb;
    color: #a32d2d;
  }
  &.tag-warning {
    background: #faeeda;
    color: #854f0b;
  }
  &.tag-opportunity {
    background: #e1f5ee;
    color: #0f6e56;
  }
  &.tag-info {
    background: #eeedfe;
    color: #3c3489;
  }
}
.nd-item-desc {
  font-size: 12px;
  color: #606266;
  margin: 0 0 4px 12px;
  line-height: 1.4;
}
.nd-item-meta {
  margin-left: 12px;
}
.nd-item-time {
  font-size: 11px;
  color: #c0c4cc;
}
.nd-item-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  margin-left: 12px;
}
.nd-action-btn {
  font-size: 11px;
  padding: 4px 12px;
  border: 1px solid $accent;
  color: $accent;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.12s;
  &:hover {
    background: rgba($accent, 0.08);
  }
}
.nd-dismiss-btn {
  opacity: 0;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  color: #c0c4cc;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.12s;
  &:hover {
    background: #fff0f0;
    color: #e24b4a;
  }
}

// Empty
.nd-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  gap: 10px;
  i {
    font-size: 36px;
    color: $accent;
  }
  span {
    font-size: 13px;
    font-weight: 600;
    color: #909399;
  }
}

// Footer
.nd-footer {
  padding: 14px 20px;
  border-top: 1px solid $border;
  flex-shrink: 0;
}
.nd-mark-all {
  width: 100%;
  padding: 8px;
  font-size: 13px;
  font-weight: 600;
  color: $primary;
  background: transparent;
  border: 1px solid $border;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.12s;
  &:hover {
    background: $bg;
    border-color: $primary;
  }
}

// Loading skeleton
.nd-loading {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.nd-skeleton-item {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.sk-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
  background: linear-gradient(90deg, #f0f2f7 25%, #e8ecf5 50%, #f0f2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
.sk-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sk-line {
  height: 10px;
  border-radius: 4px;
  background: linear-gradient(90deg, #f0f2f7 25%, #e8ecf5 50%, #f0f2f7 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  &.w50 {
    width: 50%;
  }
  &.w70 {
    width: 70%;
  }
}
@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

// Item transition
.nd-item-fade-leave-active {
  transition: opacity 0.3s, max-height 0.3s;
  overflow: hidden;
  max-height: 150px;
}
.nd-item-fade-leave-to {
  opacity: 0;
  max-height: 0;
}

// Mobile
@media (max-width: 480px) {
  .nd-drawer {
    width: 100vw;
  }
}
</style>
